import { Box, SystemIcon } from '@wishket/design-system';
import Link from 'next/link';

import NewLandingTitle from '../NewLandingTitle/NewLandingTitle';

import { PATH } from '@/shared/constants';

const TrendingCollectionsHeader = () => {
  return (
    <Link
      href={`${PATH.COLLECTION}/?tag=popular`}
      data-testid="landing-trending-collection-title-link"
    >
      <Box className="flex items-center gap-1.5">
        <NewLandingTitle title="요즘 뜨는 인기 컬렉션" />
        <SystemIcon name="medium_arrow_right" />
      </Box>
    </Link>
  );
};

export default TrendingCollectionsHeader;
